// Services
import { HttpClient } from '../../shared/HttpClient'

// Store
import store from '@/store'


// Modèles
import { Result } from '@/shared/models/Result.model'
import { InvoicingStoreMethods } from '@/store/InvoicingStore'

/**
 * Modèle de réponse API
 */
export interface InvoicingDatesDto {
  dateEnableInvoicing: string
  dateDisableVesta: string
}

export class InvoicingService {

  /**
   * Initialise le store Invoicing
   * (appelée typiquement au démarrage de l'application)
   */
  public static async init(): Promise<boolean> {
    let result = false

    await HttpClient.axios
      .get<Result<InvoicingDatesDto>>(
        'Maintenance/GetAllDatesInvoicingFeature'
      )
      .then((response) => {
        store.commit(InvoicingStoreMethods.SET_DATES, response.data)
        result = true
      })
      .catch((error) => {
        console.error('Erreur init InvoicingService', error)
        result = false
      })

    return result
  }

  /**
   * Met à jour la date d'activation de la facturation
   */
  public static setDateEnableInvoicing(
    date: string | Date
  ): void {
    store.commit(
      InvoicingStoreMethods.SET_DATE_ENABLE_INVOICING,
      date
    )
  }

  /**
   * Met à jour la date de désactivation Vesta
   */
  public static setDateDisableVesta(
    date: string | Date
  ): void {
    store.commit(
      InvoicingStoreMethods.SET_DATE_DISABLE_VESTA,
      date
    )
  }

  /**
   * Getters simples (proxy du store)
   */
  public static getDateEnableInvoicing(): Date | undefined {
    return store.getters[
      InvoicingStoreMethods.GET_DATE_ENABLE_INVOICING
    ]
  }

  public static getDateDisableVesta(): Date | undefined {
    return store.getters[
      InvoicingStoreMethods.GET_DATE_DISABLE_VESTA
    ]
  }

  public static getFormattedDateEnableInvoicing(): string {
    const date = this.getDateEnableInvoicing()
    return date ? date.toLocaleDateString('fr-FR') : ''
  }

  public static getFormattedDateDisableVesta(): string {
    const date = this.getDateDisableVesta()
    return date ? date.toLocaleDateString('fr-FR') : ''
  }


  public static isInvoicingEnabled(): boolean {
    return store.getters[
      InvoicingStoreMethods.GET_IS_INVOICING_ENABLED
    ]
  }

  public static daysBeforeEnable(): number | null {
    return store.getters[
      InvoicingStoreMethods.GET_DAYS_BEFORE_ENABLE
    ]
  }
}